'use client';

import { dynamic } from '@unifyapps/carbon/external/dynamic';
import { ApplicationType } from '@unifyapps/defs/types/interface';
import type { ReactNode } from 'react';

const NativeRegistryProvider = dynamic(
  () =>
    import(/* webpackChunkName: "matrix-registry-provider-native" */ './NativeRegistryProvider'),
);

const WebRegistryProvider = dynamic(
  () => import(/* webpackChunkName: "matrix-registry-provider-web" */ './WebRegistryProvider'),
);

type RegistryProviderLoaderProps = {
  children: ReactNode;
  platform: ApplicationType;
};

function RegistryProviderLoader({ children, platform }: RegistryProviderLoaderProps) {
  if (platform === ApplicationType.MOBILE) {
    return <NativeRegistryProvider>{children}</NativeRegistryProvider>;
  }

  return <WebRegistryProvider>{children}</WebRegistryProvider>;
}

export default RegistryProviderLoader;
